import { getObjectUtil } from 'packages/src'
import EXERCISES_PATH from '../../constants/path'

const getQueryExercisesSelect = state => getObjectUtil(state, EXERCISES_PATH.QUERY)

export default getQueryExercisesSelect
